var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.66,27A5.8,5.8,0,0,0,36,28.1,5.78,5.78,0,0,0,28.34,27,5.47,5.47,0,0,0,26,31.29c-.14,3.88,3.3,7,8.55,11.76l.1.09a2,2,0,0,0,2.69,0l.11-.1c5.25-4.76,8.68-7.87,8.55-11.75A5.47,5.47,0,0,0,43.66,27ZM36.1,41.56l-.1.1-.1-.1c-4.76-4.31-7.9-7.16-7.9-10A3.42,3.42,0,0,1,31.5,28a3.91,3.91,0,0,1,3.57,2.36h1.87A3.88,3.88,0,0,1,40.5,28a3.42,3.42,0,0,1,3.5,3.5C44,34.4,40.86,37.25,36.1,41.56Z",
    transform: "translate(-24 -22.83)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/heart-outline.119e096b40a7228495e00e533722cc09.svg";
export { ForwardRef as ReactComponent };